import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { analyticsEvent } from '../../../../actions/analytics';
import { selectUserVisibleListOfChapters } from '../../../../selectors/content';
import connect from '../../../connect';

class Chapters extends PureComponent {
    static propTypes = {
        analyticsEvent: PropTypes.func.isRequired,
        chapters: PropTypes.array,
        content: PropTypes.object,
        open: PropTypes.bool.isRequired,
        pagenum: PropTypes.number,
        closeMenu: PropTypes.func.isRequired,
    };

    onClickChapter = index => () => {
        // index should let us see how many people are just using this to get to
        // the first page of the chapter.
        this.props.analyticsEvent('material-chapter', 'click', index);
        this.props.closeMenu();
    };

    renderChapters = chapters => {
        return chapters.map((chapter, index) => {
            const tabIndex = this.props.open ? index + 1 : 0;
            let pageAural = 'Pages: ';
            let pageRange =
                chapter.first_page_label + ' - ' + chapter.last_page_label;
            if (chapter.first_page_label === chapter.last_page_label) {
                pageAural = 'Page: ';
                pageRange = chapter.first_page_label;
            }

            const linkTo = `content-${this.props.content.id}/address/${chapter.first_page}`;

            return (
                <li key={'chapter-' + chapter.first_page}>
                    <Link
                        to={linkTo}
                        onClick={this.onClickChapter(index)}
                        tabIndex={tabIndex}
                    >
                        <span className="aural">{pageAural}</span>
                        {chapter.name}{' '}
                        <span className="pageRange">{pageRange}</span>
                    </Link>
                </li>
            );
        });
    };

    render() {
        const { chapters } = this.props;
        if (chapters === null) {
            return (
                <div role="tabpanel">
                    <h1>Table of contents is not available</h1>
                </div>
            );
        }

        return (
            <ul
                role="tabpanel"
                className="toc-list"
                id="aria-navigation-panel-chapters"
                aria-labelledby="chapters-tab"
            >
                {this.renderChapters(chapters)}
            </ul>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        chapters: selectUserVisibleListOfChapters(state, props.content),
    };
}

export default connect(
    mapStateToProps,
    {
        analyticsEvent,
    }
)(Chapters);



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/toc/chapters.jsx